import { useCurrentUser } from 'hooks/useCurrentUser'
import { useInfiniteQuery } from 'hooks/useInfiniteQuery'

import { fetchUserRooms } from 'utils/queries'

import { Room } from 'types/chat'

export const useUserRooms = () => {
  const { data: currentUser } = useCurrentUser()

  return useInfiniteQuery<Room[]>(
    ['rooms', currentUser?.id],
    async ({ pageParam }) => {
      const roomsData = await fetchUserRooms(
        { userId: currentUser?.id || '' },
        {
          lastVisible: pageParam,
          limit: 20,
          order: 'lastMessage.created' as any,
          orderDirection: 'desc',
        },
      )

      return roomsData
    },
    {
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1].lastMessage?.created
      },
    },
  )
}
